import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { afterItems, beforeItems } from "../data/beforeAfter";
import { SectionCTA } from "./SectionCTA";
export function BeforeAfterSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-43" data-mp="po2498ci3ykz">
      <div className="mx-auto max-w-5xl" data-id="element-44" data-mp="ppn2p91xs1o4">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[30px] font-extrabold leading-tight text-ink md:text-5xl" data-id="element-45" data-mp="kwtzipm491e5">
          What changes when you use the <span className="text-brand" data-id="element-46" data-mp="znsyra12adl2">Ortho Case Command Center™</span>
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-47" data-mp="uozl9hlrymkw">
          <article className="overflow-hidden rounded-3xl border border-alert/20 bg-alert-light/40" data-id="element-48" data-mp="18ld5uzllv43l">
            <div className="bg-alert px-5 py-4 text-white" data-id="element-49" data-mp="13ov2o45xbdtd">
              <p className="text-sm font-extrabold uppercase tracking-wider" data-id="element-50" data-mp="3adrmzwgbs4iy">Before</p>
              <h3 className="text-xl font-bold" data-id="element-51" data-mp="35ey75xdkg1fm">Planning from a blank page</h3>
            </div>
            <ul className="space-y-4 p-5 md:p-6" data-id="element-52" data-mp="36ojljhosr0ht">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-relaxed text-ink" data-id="element-53" data-mp="3bnmei3ri5g9f">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-alert text-white" data-id="element-54" data-mp="3gmplvuuyfykk">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-55" data-mp="3ldxx8wfuhu0d" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>

          <article className="overflow-hidden rounded-3xl bg-navy-900 text-white" data-id="element-56" data-mp="3udkxvg0r2vsd">
            <div className="bg-cta px-5 py-4" data-id="element-57" data-mp="37t8wjyplp75">
              <p className="text-sm font-extrabold uppercase tracking-wider" data-id="element-58" data-mp="394bwhkbysx7">After</p>
              <h3 className="text-xl font-bold" data-id="element-59" data-mp="85urz4w4xoim">With the Ortho Case Command Center™</h3>
            </div>
            <ul className="space-y-4 p-5 md:p-6" data-id="element-60" data-mp="2507ovdhp0jkx">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[16px] leading-relaxed text-white/90" data-id="element-61" data-mp="29zajs53yl9f6">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-cta text-white" data-id="element-62" data-mp="21ycoo972vmaq">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-63" data-mp="1x0b5lo9njmz9" />
                  </span>
                  {item}
                </li>)}
            </ul>
            <div className="mx-5 mb-5 rounded-2xl bg-white/10 p-4 md:mx-6 md:mb-6" data-id="element-64" data-mp="26vuys2wu07kb">
              <p className="text-sm font-bold uppercase tracking-wide text-brand-cyan" data-id="element-65" data-mp="2kvnktkxexzly">And most importantly:</p>
              <p className="mt-1 text-lg font-bold" data-id="element-66" data-mp="2fwax6xypwoib">You have a visual system you can reuse for the next case.</p>
            </div>
          </article>
        </div>

        <SectionCTA label="I want to stop planning from a blank page" data-id="element-67" data-mp="2pnfew5fs2ngu" />
      </div>
    </section>;
}